import React from "react";
import { useSelector } from "react-redux";
import { actionCreators } from "./redux/attendanceSagas";
import SectionContainer from "../../../components/sectionContainer/sectionContainer";
import TopPerformers from "./smartComponents/topPerformers";
import PoorPerformers from "./smartComponents/poorPerformers";
import ClassByType from "./smartComponents/classByType";
import NewCustomers from "./smartComponents/newCustomers";
import ExistingCustomers from "./smartComponents/existingCustomers";
import LoadingAnimation from "../../../components/loadingAnimation/loadingAnimation";
import SectionToggle from "../../../components/sectionToggle/sectionToggle";
import KBLearnMore from "../../../components/learnMore/KBLearnMore";
import isEmpty from "lodash/isEmpty";
import { useFetchData } from "../hooks/dataFetchingHooks";
import NoData from "../../../components/noData/noData";
import { ILEARN_URLS } from "../../../constants/ilearnUrls";

const AttendanceModule = (props) => {
  useFetchData({
    moduleName: "attendance",
    props,
    fetchData: actionCreators.fetchCurrentUser,
    updateData: actionCreators.updateAllData
  });

  const {
    topPerformers,
    poorPerformers,
    isLoading,
    activeClients: { newVisits, existingVisits }
  } = useSelector((state) => state.attendance);

  const content = () => {
    if (isLoading) {
      return <LoadingAnimation />;
    }

    return !isEmpty(topPerformers) ||
      !isEmpty(poorPerformers) ||
      newVisits > 0 ||
      existingVisits > 0 ? (
      <div id="attendance-widget" className="widget-wrapper attendanceWidget active">
        <div id="attendanceModule">
          <div className="section-group ">
            {/*If topPerformers array exists, iterate through it*/}
            {!isEmpty(topPerformers) ? (
              <SectionContainer title="Top Performers" toolTip="Ranked by Class Attendance">
                {topPerformers.map((_, index) => {
                  return (
                    <span className="width-50" key={index}>
                      <TopPerformers index={index} topPerformer />
                    </span>
                  );
                })}
              </SectionContainer>
            ) : (
              <div className="error">No data for top performers</div>
            )}

            {/*If poorPerformers array exists, iterate through it*/}
            {!isEmpty(poorPerformers) ? (
              <SectionContainer title="Poor Performers">
                {poorPerformers.map((_, index) => {
                  return (
                    <span className="width-50" key={index}>
                      <PoorPerformers index={index} />
                    </span>
                  );
                })}
              </SectionContainer>
            ) : (
              <p className="error">No data for poor performers</p>
            )}
          </div>
          <div className="section-group padding">
            <SectionContainer customStyles="padding-bottom" title="Class By Type Attendance">
              <ClassByType />
            </SectionContainer>
            {newVisits > 0 || existingVisits > 0 ? (
              <SectionContainer customStyles="no-padding" title="Active Clients">
                <div className="donut-wrapper">
                  <NewCustomers />
                </div>
                <div className="donut-wrapper">
                  <ExistingCustomers />
                </div>
              </SectionContainer>
            ) : (
              <div className="error">No data for active clients</div>
            )}
          </div>
        </div>
      </div>
    ) : (
      <NoData size="big" />
    );
  };

  return (
    <SectionToggle
      title="Attendance"
      autoHeight
      isLoading={isLoading}
      maxHeight={800}
      learnMore={
        <KBLearnMore
          title="Attendance"
          description="This report shows total attendance activity across all visit types, giving you a clear breakdown of how members are engaging. These insights help you identify trends, monitor participation, and adjust operations as needed."
          kbUrl={ILEARN_URLS.dashboard.attendance}
        />
      }
      content={content()}
    />
  );
};

export default React.memo(AttendanceModule);
